import { render, staticRenderFns } from "./Marques.vue?vue&type=template&id=3ca3a751&"
import script from "./Marques.vue?vue&type=script&lang=js&"
export * from "./Marques.vue?vue&type=script&lang=js&"
import style0 from "./Marques.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports